import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { APPLICATIONINSIGHTS_CONNECTION_STRING } from './env';

export const reactPlugin = new ReactPlugin();

let appInsights: ApplicationInsights | null = null;

// Only initialize Application Insights if connection string is provided
if (APPLICATIONINSIGHTS_CONNECTION_STRING && APPLICATIONINSIGHTS_CONNECTION_STRING.trim() !== '') {
    appInsights = new ApplicationInsights({
        config: {
            connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING,
            enableAutoRouteTracking: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            extensions: [reactPlugin]
        }
    });

    appInsights.loadAppInsights();
} else {
    console.warn('Application Insights connection string not configured. Telemetry is disabled.');
}

export { appInsights };
